import { Icon } from '@sunwebgroup/uds-ui/icon'
import { useIntl } from 'react-intl'
import { useUser } from '@/domain/user/hooks'
import { buildBookingUrl } from '@/scopes/account/common/policies/bookingUrl'
import { TopNavigationBarItem } from '@/scopes/common/components/Header'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { PaymentBackButton } from '@/scopes/payment/components/PaymentBackButton'
import { usePaymentContext } from '@/scopes/payment/domain/PaymentContext'
import styles from './BookingButton.module.css'

export function GoToBookingPageButton() {
  const { isLoggedIn } = useUser()
  const intl = useIntl()
  const siteName = useConfiguration('siteName')
  const { bookingNumber } = usePaymentContext()

  if (!isLoggedIn || !bookingNumber) {
    return null
  }

  const url = buildBookingUrl(siteName, bookingNumber, true) ?? buildBookingUrl(siteName, bookingNumber)

  if (!url) {
    return null
  }

  return (
    <PaymentBackButton className={styles.backButton}>
      <TopNavigationBarItem className={styles.backButton} as="a" href={url}>
        <Icon glyph="ChevronLeft" />
        {intl.formatMessage({ id: 'payment_scope_booking_payment_go_to_booking_page' })}
      </TopNavigationBarItem>
    </PaymentBackButton>
  )
}
